export interface ProjectMeta {
  title: string;
  category: string;
  cat: string;
  hero: string;
  area: string;
  location: string;
  description: string;
  gallery: { src: string; tag: string }[];
  specs?: string[];
}

export interface CategoryDef {
  id: string;
  label: string;
  desc: string;
  cover: string;
  projectSlugs: string[];
}

export const CATEGORIES: CategoryDef[] = [
  {
    id: "home-interiors",
    projectSlugs: [
      "mummaneni-residency",
      "gem-nakshatra",
      "honer-aquantis",
      "kmv-vivaan",
      "my-home-abhra",
      "prestige-beverly-hills",
      "rajpushpa-provincia",
      "rajpushpa-regalia",
      "vasavi-lake-city"
    ],
    label: "Home Interiors",
    desc: "Complete luxury 2BHK, 3BHK & villa transformations",
    cover: "/images/services/home-interior.jpg",
  },
  {
    id: "commercial",
    projectSlugs: [
      "vasavi-sky-city",
      "eon-hyderabad-by-navanaami",
      "vyshnavi-cynosure",
      "manjeera-trinity",
      "jayabheri-silicon-towers",
      "indwell-square",
      "empire-estates",
      "novel-office"
    ],
    label: "Commercial Spaces",
    desc: "Inspiring retail, corporate and office environments",
    cover: "/images/projects/office/apa-singh-Hx8e7lW9BXI-unsplash.jpg",
  },
  {
    id: "turnkey",
    projectSlugs: [],
    label: "Turnkey Projects",
    desc: "Complete design-to-handover premium completions",
    cover: "/images/services/turnkey.jpg",
  },
  {
    id: "custom-furniture",
    projectSlugs: [],
    label: "Custom Furniture",
    desc: "Handcrafted, custom storage, tables and upholstery",
    cover: "/images/projects/ankura/IMG_0480.jpg",
  },
];

export const PROJECT_META: Record<string, ProjectMeta> = {
  "mummaneni-residency": {
    title: "Mummaneni Residency",
    category: "Home Interiors",
    cat: "home-interiors",
    hero: "/images/projects/mummaneni-residency/Pavan-1.jpg",
    area: "2,400 Sq.Ft.",
    location: "Benz Circle, Vijayawada",
    description: "A sophisticated contemporary 3BHK flat transformation at Mummaneni Residency, Vijayawada featuring illuminated fluted glass vitrines, bespoke dining vanity with backlit emerald quartzite stone, modern sage green modular kitchen, and dual-tone designer wardrobes.",
    specs: [
      "Full-height living room TV media wall with warm perimeter cove lighting and fluted rose-gold glass vitrine",
      "Designer dining hand-wash vanity with backlit emerald quartzite stone and forest-motif ceramic vessel sink",
      "Ergonomic sage green modular kitchen with tinted glass wall cabinets and integrated tall pantry tower",
      "Custom 6-door floor-to-ceiling wardrobe and dual-tone sliding closets with geometric gold inlays"
    ],
    gallery: [
      { src: "/images/projects/mummaneni-residency/Pavan-1.jpg", tag: "Living Room & TV Unit" },
      { src: "/images/projects/mummaneni-residency/Pavan-4.jpg", tag: "Modular Kitchen" },
      { src: "/images/projects/mummaneni-residency/Pavan-wash-vert.jpg", tag: "Dining Hand-Wash Vanity" },
      { src: "/images/projects/mummaneni-residency/Pavan-6.jpg", tag: "Master Bedroom Wardrobe" },
      { src: "/images/projects/mummaneni-residency/Pavan-7.jpg", tag: "Bedroom 2 Wardrobe" },
      { src: "/images/projects/mummaneni-residency/Pavan-2.jpg", tag: "Dining & Crockery Sideboard" },
      { src: "/images/projects/mummaneni-residency/Pavan-5.jpg", tag: "Kitchen Pantry" },
      { src: "/images/projects/mummaneni-residency/Pavan-8.jpg", tag: "Bedroom 3 Wardrobe" },
      { src: "/images/projects/mummaneni-residency/Pavan-9.jpg", tag: "Dressing Vanity" },
      { src: "/images/projects/mummaneni-residency/Pavan-3.jpg", tag: "Artisan Basin Detail" }
    ]
  },
  "gem-nakshatra": {
    title: "Gem Nakshatra",
    category: "Home Interiors",
    cat: "home-interiors",
    hero: "/images/projects/gem-nakshatra/Gem1.jpg",
    area: "3,150 Sq.Ft.",
    location: "Kokapet, Hyderabad",
    description: "An elegant, bespoke home transformation at Gem Nakshatra featuring state-of-the-art modular kitchen solutions, beautiful custom layouts, and a clean contemporary visual flow.",
    specs: [
      "German-finish acrylic modular kitchen with soft-close tandem drawers",
      "Boiling Water Resistant (BWR) marine plywood core understructures",
      "Concealed warm profile lighting and integrated custom storage cabinetry",
      "High-durability anti-scratch laminate wardrobe panels"
    ],
    gallery: [
      { src: "/images/projects/gem-nakshatra/Gem1.jpg", tag: "Pooja Unit" },
      { src: "/images/projects/gem-nakshatra/Gem2.jpg", tag: "Kitchen" },
      { src: "/images/projects/gem-nakshatra/Gem4.jpg", tag: "Wardrobe" },
      { src: "/images/projects/gem-nakshatra/Gem6.jpg", tag: "Wardrobe" },
      { src: "/images/projects/gem-nakshatra/Gem7.jpg", tag: "Pooja Unit" }
    ]
  },
  "honer-aquantis": {
    title: "Honer Aquantis",
    category: "Home Interiors",
    cat: "home-interiors",
    hero: "/images/projects/honer-aquantis/Honer.jpg",
    area: "2,450 Sq.Ft.",
    location: "Nallagandla, Gachibowli",
    description: "An expansive, light-filled premium high-rise apartment transformation featuring customized modern wardrobes, false ceilings, and layered architectural light elements.",
    specs: [
      "Saint-Gobain gypsum fire-resistant custom false ceilings",
      "Integrated dimmable LED profile tracks and magnetic spot lighting",
      "Handcrafted master bedroom storage units and walk-in dressing layout",
      "Bespoke modular TV wall with luxury fluted wooden panel backdrops"
    ],
    gallery: [
      { src: "/images/projects/honer-aquantis/Honer.jpg", tag: "Pooja Room" },
      { src: "/images/projects/honer-aquantis/Honer(2).jpg", tag: "Living Room" },
      { src: "/images/projects/honer-aquantis/Honer(5).jpg", tag: "Study Room" },
      { src: "/images/projects/honer-aquantis/Honer(7).jpg", tag: "Kitchen" },
      { src: "/images/projects/honer-aquantis/Honer(10).jpg", tag: "Bedroom" },
      { src: "/images/projects/honer-aquantis/Honer(13).jpg", tag: "Foyer" },
      { src: "/images/projects/honer-aquantis/Honer(16).jpg", tag: "Living Room" }
    ]
  },
  "kmv-vivaan": {
    title: "KMV Vivaan",
    category: "Home Interiors",
    cat: "home-interiors",
    hero: "/images/projects/kmv-vivaan/KMV.jpg",
    area: "3,800 Sq.Ft.",
    location: "Vijayawada",
    description: "A gorgeous luxury villa makeover utilizing premium materials, anti-fingerprint matte textures, and personalized custom furniture.",
    specs: [
      "Ergonomic kitchen layout featuring premium anti-fingerprint matte laminates",
      "High-density moisture-resistant wood core frames for ultimate durability",
      "Elegant custom teakwood partition screens and Pooja room doors",
      "Veneer-finish heavy sliding doors and high-capacity wardrobes"
    ],
    gallery: [
      { src: "/images/projects/kmv-vivaan/KMV.jpg", tag: "Living Room Partition" },
      { src: "/images/projects/kmv-vivaan/KMV(1).jpg", tag: "Kitchen" },
      { src: "/images/projects/kmv-vivaan/KMV(2).jpg", tag: "Living Room" },
      { src: "/images/projects/kmv-vivaan/KMV(3).jpg", tag: "Bedroom" },
      { src: "/images/projects/kmv-vivaan/KMV(6).jpg", tag: "Kitchen" },
      { src: "/images/projects/kmv-vivaan/KMV(8).jpg", tag: "Wardrobe" }
    ]
  },
  "my-home-abhra": {
    title: "My Home Abhra",
    category: "Home Interiors",
    cat: "home-interiors",
    hero: "/images/projects/my-home-abhra/MH Abhra(12).jpg",
    area: "2,850 Sq.Ft.",
    location: "Madhapur, Hyderabad",
    description: "High-end bespoke family home featuring rich wooden details, warm indirect lighting setups, and smart custom closet spaces.",
    specs: [
      "Veneer-finished custom storage units with soft-close architectural slides",
      "Warm ambient backlight arrangements in the lounge and bedrooms",
      "Teakwood rafter partitions and CNC-cut custom layout highlights",
      "Ergonomic study areas integrated cleanly with bedroom wardrobes"
    ],
    gallery: [
      { src: "/images/projects/my-home-abhra/MH Abhra(12).jpg", tag: "Living Room & TV Unit" },
      { src: "/images/projects/my-home-abhra/MH Abhra(8).jpg", tag: "Modular Kitchen" },
      { src: "/images/projects/my-home-abhra/MH Abhra(7).jpg", tag: "Bespoke Wardrobe" },
      { src: "/images/projects/my-home-abhra/MH Abhra(6).jpg", tag: "Foyer Vanity" },
      { src: "/images/projects/my-home-abhra/MH Abhra(11).jpg", tag: "Backlit Pooja Niche" },
      { src: "/images/projects/my-home-abhra/MH Abhra(14).jpg", tag: "Master Bedroom" },
      { src: "/images/projects/my-home-abhra/MH Abhra.jpg", tag: "Bathroom Vanity" }
    ]
  },
  "prestige-beverly-hills": {
    title: "Prestige Beverly Hills",
    category: "Home Interiors",
    cat: "home-interiors",
    hero: "/images/projects/prestige-beverly-hills/FB_IMG_1778706395280.jpg",
    area: "3,400 Sq.Ft.",
    location: "Kokapet, Hyderabad",
    description: "An absolute visual masterpiece utilizing state-of-the-art sliding wardrobe mechanics, warm lighting layouts, and custom-finished storage units.",
    specs: [
      "Heavy-duty sliding mechanism wardrobe systems with soft-close tech",
      "Lacquered glass details and premium high-gloss laminates on panels",
      "18mm core BWR marine plywood frames throughout for durability",
      "Custom floating TV console with hidden wire channels"
    ],
    gallery: [
      { src: "/images/projects/prestige-beverly-hills/FB_IMG_1778706395280.jpg", tag: "Foyer Console" },
      { src: "/images/projects/prestige-beverly-hills/FB_IMG_1778706397054.jpg", tag: "Study Area" },
      { src: "/images/projects/prestige-beverly-hills/FB_IMG_1778706401845.jpg", tag: "Kitchen" },
      { src: "/images/projects/prestige-beverly-hills/FB_IMG_1778706405050.jpg", tag: "Master Bedroom" },
      { src: "/images/projects/prestige-beverly-hills/FB_IMG_1778706409443.jpg", tag: "TV Console" },
      { src: "/images/projects/prestige-beverly-hills/FB_IMG_1778706421090.jpg", tag: "Smart Wardrobe" }
    ]
  },
  "rajpushpa-provincia": {
    title: "Rajpushpa Provincia",
    category: "Home Interiors",
    cat: "home-interiors",
    hero: "/images/projects/rajpushpa-provincia/Provincia.jpg",
    area: "2,600 Sq.Ft.",
    location: "Narsingi, Hyderabad",
    description: "An elegant contemporary residential space designed around fluid geometric lines, premium veneers, and ambient mood lighting.",
    specs: [
      "Saint-Gobain premium false ceiling with wooden panel accents",
      "Soft-close Hettich modular kitchen and custom drawers",
      "Concealed LED strip channel backlights behind mirrors and headboards",
      "Custom anti-scratch matte laminate sliding wardrobe panels"
    ],
    gallery: [
      { src: "/images/projects/rajpushpa-provincia/Provincia.jpg", tag: "Living Room" },
      { src: "/images/projects/rajpushpa-provincia/Provincia(1).jpg", tag: "Storage Unit" },
      { src: "/images/projects/rajpushpa-provincia/Provincia(3).jpg", tag: "Kitchen" },
      { src: "/images/projects/rajpushpa-provincia/Provincia(5).jpg", tag: "Master Bedroom" },
      { src: "/images/projects/rajpushpa-provincia/Provincia(7).jpg", tag: "Wardrobe" },
      { src: "/images/projects/rajpushpa-provincia/Provincia(12).jpg", tag: "TV Unit" }
    ]
  },
  "rajpushpa-regalia": {
    title: "Rajpushpa Regalia",
    category: "Home Interiors",
    cat: "home-interiors",
    hero: "/images/projects/rajpushpa-regalia/FB_IMG_1778706464837.jpg",
    area: "3,250 Sq.Ft.",
    location: "Kokapet, Hyderabad",
    description: "A luxury high-rise apartment transformation displaying stunning modular kitchen integrations, floor-to-ceiling closets, and gold-leaf details.",
    specs: [
      "Custom gold-leaf detailed false ceilings in drawing room",
      "German-finish acrylic modular kitchen with smart corner systems",
      "Teakwood rafters and custom stone cladding on entry walls",
      "Walk-in wardrobe closets with full-height mirrors and sensors"
    ],
    gallery: [
      { src: "/images/projects/rajpushpa-regalia/FB_IMG_1778706464837.jpg", tag: "Living Room & TV Unit" },
      { src: "/images/projects/rajpushpa-regalia/FB_IMG_1778706459952.jpg", tag: "Modular Kitchen" },
      { src: "/images/projects/rajpushpa-regalia/FB_IMG_1778706455883.jpg", tag: "Smart Wardrobe" },
      { src: "/images/projects/rajpushpa-regalia/FB_IMG_1778706461373.jpg", tag: "Master Bedroom" },
      { src: "/images/projects/rajpushpa-regalia/FB_IMG_1778706447462.jpg", tag: "Foyer Console" }
    ]
  },
  "vasavi-lake-city": {
    title: "Vasavi Lake City",
    category: "Home Interiors",
    cat: "home-interiors",
    hero: "/images/projects/vasavi-lake-city/FB_IMG_1779408543262.jpg",
    area: "2,200 Sq.Ft.",
    location: "Hafeezpet, Hyderabad",
    description: "Comfortable and extremely functional modular home design leveraging every square foot optimized for smart storage layout systems.",
    specs: [
      "Smart storage layout systems utilizing premium hardware hinges",
      "Ergonomic L-shaped kitchen layout in custom high-gloss laminates",
      "Concealed LED light channels and false ceiling gypsum boards",
      "Custom anti-scratch matte panels for master bedroom wardrobes"
    ],
    gallery: [
      { src: "/images/projects/vasavi-lake-city/FB_IMG_1779408516834.jpg", tag: "Living Room & TV Unit" },
      { src: "/images/projects/vasavi-lake-city/FB_IMG_1779408519330.jpg", tag: "Living Room Ceiling" },
      { src: "/images/projects/vasavi-lake-city/FB_IMG_1779408521179.jpg", tag: "Kitchen" },
      { src: "/images/projects/vasavi-lake-city/FB_IMG_1779408524822.jpg", tag: "Master Bedroom" },
      { src: "/images/projects/vasavi-lake-city/FB_IMG_1779408527680.jpg", tag: "Wardrobe" },
      { src: "/images/projects/vasavi-lake-city/FB_IMG_1779408543262.jpg", tag: "TV Unit Detail" }
    ]
  },
  "vasavi-sky-city": {
    title: "Vasavi Sky City",
    category: "Commercial Spaces",
    cat: "commercial",
    hero: "/images/projects/office/tina-roy-ROBCVXIoXkc-unsplash.jpg",
    area: "12,500 Sq.Ft.",
    location: "Gachibowli, Hyderabad",
    description: "A premium corporate headquarters at Vasavi Sky City designed for high productivity, featuring open-plan workstations, ergonomic glass cabins, and a modern lounge.",
    specs: [
      "High-performance double-glazed acoustic glass partitions (STC-38)",
      "Modular open-plan workstation benches with integrated power channels",
      "Custom solid-surface reception desk with backlit LED brand styling",
      "Energy-efficient linear LED grid lighting and automated HVAC zones"
    ],
    gallery: [
      { src: "/images/projects/office/tina-roy-ROBCVXIoXkc-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/tina-roy-B0dKIEpAu9M-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/tina-roy-HB6GcMj_WEc-unsplash.jpg", tag: "Office Space" }
    ]
  },
  "eon-hyderabad-by-navanaami": {
    title: "EON Hyderabad by Navanaami",
    category: "Commercial Spaces",
    cat: "commercial",
    hero: "/images/projects/office/pooja-singh-R0l_Xf6iV1E-unsplash.jpg",
    area: "8,400 Sq.Ft.",
    location: "Nanakramguda, Hyderabad",
    description: "Sleek and professional modern executive office layout at EON Hyderabad, balancing open collaboration zones with secure, private boardrooms.",
    specs: [
      "Executive boardroom with integrated smart-screen media walls",
      "Acoustical fabric desktop divider screens for focal privacy",
      "Premium veneer-finished conference and executive desks",
      "Biophilic green wall installations and air-purification setups"
    ],
    gallery: [
      { src: "/images/projects/office/pooja-singh-R0l_Xf6iV1E-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/pooja-singh-L4Cev9HX9aU-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/pooja-singh-XFdVPdXB_Q4-unsplash.jpg", tag: "Office Space" }
    ]
  },
  "vyshnavi-cynosure": {
    title: "Vyshnavi Cynosure",
    category: "Commercial Spaces",
    cat: "commercial",
    hero: "/images/projects/office/apa-singh-Hx8e7lW9BXI-unsplash.jpg",
    area: "15,200 Sq.Ft.",
    location: "Gachibowli, Hyderabad",
    description: "A multi-level tech workspace at Vyshnavi Cynosure featuring agile collaboration hubs, silent focus pods, and dynamic recreation lounges.",
    specs: [
      "Sound-insulated telephone focus booths and agile scrum spaces",
      "Modular cable-management pathways with under-desk trays",
      "Luxury terrazzo flooring combined with anti-static carpet tiles",
      "Premium modular cafeteria setup with custom cafe seating"
    ],
    gallery: [
      { src: "/images/projects/office/apa-singh-Hx8e7lW9BXI-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/apa-singh-dxiiPlE_gRs-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/apa-singh-uTCgkBX8WJU-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/apa-singh-w8rgrsRj9sk-unsplash.jpg", tag: "Office Space" }
    ]
  },
  "manjeera-trinity": {
    title: "Manjeera Trinity",
    category: "Commercial Spaces",
    cat: "commercial",
    hero: "/images/projects/office/pooja-singh-lno1MnpnhqQ-unsplash.jpg",
    area: "6,800 Sq.Ft.",
    location: "KPHB, Hyderabad",
    description: "High-density corporate space optimized for financial consultants, focusing on privacy, confidentiality, and upscale professional aesthetics.",
    specs: [
      "Confidential dual-glazed glass cabins with micro-etched patterns",
      "High-capacity server room with dedicated underfloor cooling",
      "Custom-built filing credenzas and modular overhead storage cabinets",
      "Dimmable warm spotlights and architectural gypsum ceiling guides"
    ],
    gallery: [
      { src: "/images/projects/office/pooja-singh-lno1MnpnhqQ-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/pooja-singh-tdqAFMV2aGU-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/pooja-singh-Md8kpRTWFHI-unsplash.jpg", tag: "Office Space" }
    ]
  },
  "jayabheri-silicon-towers": {
    title: "Jayabheri Silicon Towers",
    category: "Commercial Spaces",
    cat: "commercial",
    hero: "/images/projects/office/pyx-photography-FFsT8KptMiA-unsplash.jpg",
    area: "10,500 Sq.Ft.",
    location: "Kondapur, Hyderabad",
    description: "An inspiring co-working style commercial environment designed to foster community, creative design sprints, and high-energy meetings.",
    specs: [
      "Flexible hot-desking setups with wireless charging surfaces",
      "Preserved moss green wall accents and biophilic partitions",
      "State-of-the-art interactive smartboard meeting rooms",
      "Heavy-gauge powder-coated structural steel framing"
    ],
    gallery: [
      { src: "/images/projects/office/pyx-photography-FFsT8KptMiA-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/pyx-photography-eSKkEgvhq_I-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/the-yardcoworking-FnYzxrHSFeo-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/the-yardcoworking-y-d0sHFxPX0-unsplash.jpg", tag: "Office Space" }
    ]
  },
  "indwell-square": {
    title: "Indwell Square",
    category: "Commercial Spaces",
    cat: "commercial",
    hero: "/images/projects/office/tina-roy-6qOYUxXqChQ-unsplash.jpg",
    area: "5,400 Sq.Ft.",
    location: "Vijayawada",
    description: "A corporate regional office displaying clean minimalistic desk arrangements, integrated branding panels, and welcoming client interview areas.",
    specs: [
      "Minimalist modern reception lobby with linear light rails",
      "Custom laminate-finished pantry and storage credenzas",
      "Ergonomic executive mesh seating and task-focused lighting",
      "Saint-Gobain false ceilings with acoustic acoustic baffles"
    ],
    gallery: [
      { src: "/images/projects/office/tina-roy-6qOYUxXqChQ-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/tina-roy-N156G-CVB4M-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/tina-roy-ZPAOg6fuXtg-unsplash.jpg", tag: "Office Space" }
    ]
  },
  "empire-estates": {
    title: "Empire Estates",
    category: "Commercial Spaces",
    cat: "commercial",
    hero: "/images/projects/office/pooja-singh-96wVqPgSuPA-unsplash.jpg",
    area: "9,200 Sq.Ft.",
    location: "Bengaluru",
    description: "A highly premium boutique office layout at Empire Estates tailored for legal partners, featuring deep oak veneers and leather upholstery accents.",
    specs: [
      "Bespoke solid oak veneer executive library shelving units",
      "Leather-upholstered conference room seating and glass tables",
      "Dimmable high-end architectural track spotlighting",
      "Soundproof gypsum lining on perimeter walls (STC-45)"
    ],
    gallery: [
      { src: "/images/projects/office/pooja-singh-96wVqPgSuPA-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/pooja-singh-Mu2gjZKBFJE-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/pooja-singh-749kHc86kZU-unsplash.jpg", tag: "Office Space" }
    ]
  },
  "novel-office": {
    title: "Novel Office",
    category: "Commercial Spaces",
    cat: "commercial",
    hero: "/images/projects/office/exospace-hyderabad-BGFr5hueWVY-unsplash.jpg",
    area: "14,000 Sq.Ft.",
    location: "Bengaluru",
    description: "A modern, highly flexible agile corporate hub optimized for fast-growing technology startups requiring quick spatial adaptations.",
    specs: [
      "Movable architectural glass wall systems for swift floor plans",
      "Heavy-duty overhead cable ladders and utility access points",
      "Collaborative whiteboard walls and stadium brainstorming steps",
      "Low-VOC paint coatings and eco-friendly recycled flooring tiles"
    ],
    gallery: [
      { src: "/images/projects/office/exospace-hyderabad-BGFr5hueWVY-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/tina-roy-cwn5V1-d2T4-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/barun-ghosh-VyjIVZOVmFg-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/myhq-workspaces-NEFgreoVtig-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/perminder-kumar-cSFjn543npc-unsplash.jpg", tag: "Office Space" },
      { src: "/images/projects/office/file_00000000a2ec72089fe21a673ca20414.jpg", tag: "Office Space" }
    ]
  }
};
